const isPro = Object.is(process.env.NODE_ENV, 'production')
//判断当前环境是生产环境还是开发环境
module.exports = {
    baseUrl: isPro ? '' : 'api/',
    isPro: isPro
}


//////////////////
// WEBPACK FOOTER
// ./config/api.config.js
// module id = mrgY
// module chunks = 0